// Selected colors yahan store honge — ab har item ki apni quantity bhi hai
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('.collapsible-tab').forEach((el) => {
  el.addEventListener('toggle', function () {
    if (this.open) {
      document.querySelectorAll('.collapsible-tab').forEach((other) => {
        if (other !== this) other.open = false;
      });
    }
  });
});

$('.product-primary li.pdp-custom-swatch-dropdown-item:first-child').click();
var comingflat = $('.Solid.Colors li.pdp-custom-swatch-list-item').attr('data-color');
$('span.coming-flat-colors-Solid.Colors').text(comingflat);
$('.Solid.Colors li.pdp-custom-swatch-list-item').click(function(){
       var comingflat2 = $(this).attr('data-color');
       $('span.coming-flat-colors-Solid.Colors').text(comingflat2);
});
$('.Solid.Colors li.pdp-custom-swatch-list-item').click(function(){
       var comingflat2 = $(this).attr('data-color');
       $('.swatches-laces-color h3').html('<span>Color</span>'+comingflat2);
});
function toggleVideoMute(video) {
    video.muted = !video.muted;
    var $btn = $(video).siblings('.volume-button-comvdde');

    if (video.muted) {
        $btn.find('.muteed_time').show();
        $btn.find('.unmute_time').hide();
    } else {
        $btn.find('.muteed_time').hide();
        $btn.find('.unmute_time').show();
    }
}

var isProcessing = false;
function handleTap(video) {
    if (isProcessing) return;
    isProcessing = true;
    toggleVideoMute(video);
    setTimeout(function () {
        isProcessing = false;
    }, 350); // ek tap ke dauraan dobara trigger na ho
}

$('.Video-section video').on('click', function (e) {
    handleTap(this);
});

$('.Video-section .volume-button-comvdde').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var video = $(this).siblings('video').get(0);
    handleTap(video);
});

});